import React from 'react';

// Environment banner (DEV/UA). Label and color come from /env-config.js, which
// nginx generates at container start from ENV_LABEL / ENV_BANNER_COLOR in the
// environment's .env. No label (e.g. prod) means no banner.
export default function EnvBanner() {
  const { label, bannerColor } = window.ENV_CONFIG || {};
  if (!label) return null;
  return (
    <div className="env-banner" style={{ background: bannerColor || '#FFCF00' }}>
      {label}
    </div>
  );
}
